import React from 'react';

import * as appHelpers from '@src/services/helpers/appHelpers';
import translation from './translation';

import styles from './styles.module.scss';

const lang = appHelpers.loadTranslation(translation);

export function Maintenance() {
  return (
    <div className={styles.maintenance}>
      <h1>
        {lang.message}
      </h1>
    </div>
  );
}
